import React, { Component } from 'react'
import { connect } from 'react-redux'
import DutyItem from './DutyItem'
import MerchandiseLineItem_co from './MerchandiseLineItem_co'
import {get} from "lodash";
class DutyItems extends Component {
  render() {
    let { dutyItems, shipmentETA, lineItemIndex,invoiceItemIndex, isDisabled, enableLineItem , showFrightData , articleHeader, parentHts} = this.props
    if(this.props.launchFrom === 'PRODUCT_HISTORY'){
      lineItemIndex = 0;
      invoiceItemIndex = 0;
      dutyItems = get(this.props, "prodHistoryFormData.merchandiseDuties.duties", []);
    }
    return (
      <div className='duty-items'>
        {(get(dutyItems, "duties", dutyItems) || []).map((item, index) => (
          <div key={'dutyItem' + item.merchandiseDutyId}>
            <DutyItem
              launchFrom={this.props.launchFrom}
              {...this.props}
              showLineItem={this.props.showLineItem}
              key={'dutyItem' + index}
              lineItemIndex={lineItemIndex}
              invoiceItemIndex={invoiceItemIndex}
              showFrightData={showFrightData}
              index={index}
              handleFocusMID={this.props.handleFocusMID}
              articleHeader={articleHeader}
              isDisabled={isDisabled}
              parentHts={parentHts}
              indexVal={this.props.indexVal}
              enableLineItem={enableLineItem}
              shipmentETA={shipmentETA}
              MerchandiseLineItem_co={<MerchandiseLineItem_co {...this.props} updateFormState={this.props.updateFormState} launchFrom={this.props.launchFrom} prodHistoryFormData={this.props.prodHistoryFormData} lineItemIndex={lineItemIndex} invoiceItemIndex={invoiceItemIndex} isDisabled={isDisabled} enableLineItem={this.props.enableLineItem}/>}
            />
          </div>
        ))}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  if(props.launchFrom === 'PRODUCT_HISTORY'){
    return {
      dutyItems: props.merchandiseDuties,
    }
  }
    return {
      // TODO: Bug: Comnponent does not register upate when dutyItems changes, adding the length fixes but not this is a workaround, needs investigation
      invoiceItemIndex: props.invoiceItemIndex,
      dutyItemsLength:
        state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
          .merchandiseDuties.length,
      dutyItems:
        state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems[props.lineItemIndex]
          .merchandiseDuties,
      lineItemIndex: props.lineItemIndex
    }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DutyItems)
